import { IChingLineValue, IChingReading } from '../../core/iching.models';

/** Labels voor de platte tekst; de host vult ze uit i18n. */
export interface IChingConsultationLabels {
  readonly question: string;
  readonly situation: string;
  readonly lines: string;
  readonly moving: string;
  readonly changed: string;
  readonly keywords: string;
  readonly do: string;
  readonly dont: string;
  readonly notes: string;
}

export interface IChingConsultationTextInput {
  readonly question: string;
  readonly questionKind: 'question' | 'situation';
  readonly lines: readonly IChingLineValue[];
  readonly reading: IChingReading;
  readonly hexagramTitle?: string;
  readonly changedTitle?: string;
  readonly keywords: readonly string[];
  readonly doList: readonly string[];
  readonly dontList: readonly string[];
  readonly notes: string;
  /** Al opgemaakte datum (de host formatteert met moment). */
  readonly date: string;
  readonly labels: IChingConsultationLabels;
}

/**
 * Een raadpleging als platte tekst om te kopiëren: datum, vraag, lijnen
 * onder naar boven, hexagram, bewegende lijnen, omslag, trefwoorden,
 * doen/laten en notities. Lege onderdelen vallen weg. Puur.
 */
export function buildConsultationText(input: IChingConsultationTextInput): string {
  const { labels, reading } = input;
  const blocks: string[] = [input.date];

  const question = input.question.trim();
  if (question.length > 0) {
    blocks.push(`${input.questionKind === 'situation' ? labels.situation : labels.question}: ${question}`);
  }

  const hexagram = [
    `${labels.lines}: ${input.lines.join(' ')}`,
    titled(reading.primary, input.hexagramTitle),
  ];
  if (reading.movingPositions.length > 0) {
    hexagram.push(`${labels.moving}: ${reading.movingPositions.join(', ')}`);
  }
  if (reading.changed !== undefined) {
    hexagram.push(`${labels.changed}: ${titled(reading.changed, input.changedTitle)}`);
  }
  blocks.push(hexagram.join('\n'));

  if (input.keywords.length > 0) {
    blocks.push(`${labels.keywords}: ${input.keywords.join(', ')}`);
  }
  for (const [label, list] of [
    [labels.do, input.doList],
    [labels.dont, input.dontList],
  ] as const) {
    if (list.length > 0) {
      blocks.push([`${label}:`, ...list.map(item => `- ${item}`)].join('\n'));
    }
  }

  const notes = input.notes.trim();
  if (notes.length > 0) {
    blocks.push(`${labels.notes}:\n${notes}`);
  }
  return blocks.join('\n\n');
}

function titled(number: number, title: string | undefined): string {
  return title ? `#${number} ${title}` : `#${number}`;
}
